export default __webpack_public_path__ + "static/media/mongodb-negative.32503683.svg";